import(/* webpackMode: "eager" */ "/codebuild/output/src272999403/src/SleepFront/node_modules/@next/third-parties/dist/google/ga.js");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src272999403/src/SleepFront/node_modules/@next/third-parties/dist/google/gtm.js");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src272999403/src/SleepFront/node_modules/@next/third-parties/dist/ThirdPartyScriptEmbed.js");
;
import(/* webpackMode: "eager", webpackExports: ["Analytics"] */ "/codebuild/output/src272999403/src/SleepFront/node_modules/@vercel/analytics/dist/react/index.mjs");
;
import(/* webpackMode: "eager", webpackExports: ["SpeedInsights"] */ "/codebuild/output/src272999403/src/SleepFront/node_modules/@vercel/speed-insights/dist/next/index.mjs");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/codebuild/output/src272999403/src/SleepFront/node_modules/next-intl/dist/esm/shared/NextIntlClientProvider.js");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src272999403/src/SleepFront/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src272999403/src/SleepFront/node_modules/next/dist/client/link.js");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src272999403/src/SleepFront/node_modules/next/dist/client/script.js");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src272999403/src/SleepFront/src/app/assets/bear_off.png");
;
import(/* webpackMode: "eager", webpackExports: ["Footer"] */ "/codebuild/output/src272999403/src/SleepFront/src/app/ui/Footer/Footer.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Header"] */ "/codebuild/output/src272999403/src/SleepFront/src/app/ui/Header/Header.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["AttributionCapture"] */ "/codebuild/output/src272999403/src/SleepFront/src/app/ui/Layout/AttributionCapture.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["CookieBanner"] */ "/codebuild/output/src272999403/src/SleepFront/src/app/ui/Layout/CookieBanner.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Hotjar"] */ "/codebuild/output/src272999403/src/SleepFront/src/app/ui/Layout/Hotjar.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/codebuild/output/src272999403/src/SleepFront/src/shared/ui/ErrorBoundary/ErrorBoundary.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ErrorHandlerInitializer"] */ "/codebuild/output/src272999403/src/SleepFront/src/shared/ui/ErrorBoundary/ErrorHandlerInitializer.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ProviderErrorFallback"] */ "/codebuild/output/src272999403/src/SleepFront/src/shared/ui/ErrorBoundary/ProviderErrorFallback.tsx");
